import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { CardapioService, DestaquesDoDia } from '@mobile/app/services/cardapio/cardapio.service';
import { descricaoHorario, descricaoVigencia } from '@mobile/helpers/vigencia.helper';
import { Desconto, Produto } from '@mobile/models/cardapio/cardapio.model';

@Component({
  selector: 'app-destaques-dia',
  templateUrl: './destaques-dia.component.html',
  styleUrls: ['./destaques-dia.component.scss'],
})
export class DestaquesDiaComponent implements OnInit {

  destaques?: DestaquesDoDia;
  promocoesAbertas = false;

  constructor(
    private cardapioService: CardapioService,
    private router: Router,
    private toastCtrl: ToastController,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const destaques = await this.cardapioService.getDestaquesDoDia();
      this.destaques = destaques.promocoes.length || destaques.combos.length ? destaques : undefined;
    } catch (err: unknown) {
      // Sem destaques a home segue normal.
      console.error('home: falha ao carregar promoções e combos do dia', err);
    }
  }

  get resumo(): string {
    const { promocoes, combos } = this.destaques!;
    const partes: string[] = [];
    if (promocoes.length) {
      partes.push(`${promocoes.length} ${promocoes.length === 1 ? 'promoção' : 'promoções'}`);
    }
    if (combos.length) {
      partes.push(`${combos.length} ${combos.length === 1 ? 'combo' : 'combos'}`);
    }
    return `${partes.join(' e ')} para você!`;
  }

  desconto(desconto?: Desconto): string {
    if (!desconto) {
      return '';
    }
    switch (desconto.tipo) {
      case 'percentual': return `${desconto.valor}% OFF`;
      case 'valor': return `R$ ${desconto.valor} OFF`;
      case 'preco': return `por R$ ${desconto.valor}`;
    }
  }

  horario(produto: Produto): string {
    return descricaoHorario(produto.vigencia);
  }

  alternarPromocoes(): void {
    this.promocoesAbertas = !this.promocoesAbertas;
  }

  async verCombos(): Promise<void> {
    if (!this.destaques) {
      return;
    }
    if (this.destaques.combosDisponiveisAgora) {
      await this.router.navigate(['/tabs/cardapio/combos']);
      return;
    }
    const quando = descricaoVigencia(this.destaques.combos[0].vigencia);
    const toast = await this.toastCtrl.create({
      message: `Os combos de hoje ainda não começaram: ${quando}.`,
      duration: 3500,
      position: 'top',
    });
    await toast.present();
  }
}
